/**
 * @name game-devices.constants
 * @description Core game-devices.constants in ngx-responsive
 *
 * @license MIT
 */
import { IGameDevices } from '../interfaces';

export const GAME_DEVICES: IGameDevices = {
    PS4: 'Playstation 4',
    PS3: 'Playstation 3',
    XBOX_ONE: 'Xbox One',
    XBOX: 'Xbox',
    WII: 'Wii',
    WII_U: 'Wii U',
    NINTENDO_3DS: 'Nintendo 3DS',
    PLAYSTATION_VITA: 'Playstation Vita',
    PSP: 'PSP'
};

